// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"681d08bf","453":"aaac4e45","455":"031aec70","977":"fb1ae32e"}[chunkId] + ".chunk.js";
};